import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { CustomLayoutRoutes } from 'src/app/services/navigation-services/custom-layout-routes.service';
import { LoginModel, OnboardingStatus } from 'src/app/models/login';
import { environment as env } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { Util } from 'src/app/services/Util';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component( {
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.css' ]
} )
export class LoginComponent implements OnInit {
  loginDetails: LoginModel = { Username: "", Password: "" };
  alert: string;
  isError: boolean;
  isLoading: boolean;
  showPassword: boolean;

  constructor ( private auth: AuthService, private errorEvent: EventService, private customLayoutRoute: CustomLayoutRoutes, private activatedRoute: ActivatedRoute,private snackbar: SnackbarService ) {

  }

  async ngOnInit () {
    this.auth.logoutUser();
    this.errorEvent.httpErrorMessageEvent.subscribe( message => {
      if ( message ) {
        let i = this.errorEvent.getErrID();
        if ( message.includes( i ) ) {
          message = message.replace( i, '' );
        }
      }
      this.alert = message;
      this.isError = true;
      this.snackbar.error(message);
    } );

    if(this.activatedRoute.snapshot.queryParams.jwtUserJson){
      const jwtUserJson = this.activatedRoute.snapshot.queryParams.jwtUserJson;

      const jwtUser = JSON.parse(jwtUserJson);

      this.auth.setLoginUser(jwtUser);
      this.postLogin(jwtUser);
    }
  }

  togglePassword () {
    this.showPassword = !this.showPassword;
    document.getElementById( 'password' ).attributes[ 'type' ].value = this.showPassword ? "text" : "password";
  }

  async onSubmit () {
    try {
      const jwtUser = await this.auth.loginUser( this.loginDetails.Username, this.loginDetails.Password );

      const currentSubdomain = Util.getSubdomain();
      const userSubdomain = jwtUser.subdomain;

      if(!currentSubdomain){
        const jwtUserJson = JSON.stringify(jwtUser);
        document.location.href = `//${userSubdomain}.${document.location.host}/login?jwtUserJson=${encodeURIComponent(jwtUserJson)}`;
        return;
      }
      else{
        this.postLogin(jwtUser);
      }
      
    }
    catch ( err ) {
      console.log(err);
    }
  }

  postLogin(jwtUser: any){
    const user = JSON.stringify( jwtUser );
      sessionStorage.setItem( "_user", user );
      const cd = JSON.parse( this.auth.getCookie( env.clientInformationStore ) );
      if ( jwtUser.forceReset ) {
        this.customLayoutRoute.navigateToUpdatePassword();
        return;
      }
      if ( cd && (cd.status == OnboardingStatus.AwaitingEmailVerification || cd.status == OnboardingStatus.AwaitingProfileCompletion) ) {
        this.customLayoutRoute.navigateToRegister();
      }
      else {
        //const test = cd.status == OnboardingStatus.AwaitingApproval;
        this.customLayoutRoute.navigateToMainPage();
      }
  }
}